var WalletType = /* @__PURE__ */ ((WalletType2) => {
  WalletType2["DEFAULT"] = "default";
  WalletType2["SECRET"] = "secret";
  WalletType2["INSTANT"] = "instant";
  WalletType2["DAILY"] = "daily";
  WalletType2["WEEKLY"] = "weekly";
  WalletType2["MONTHLY"] = "monthly";
  return WalletType2;
})(WalletType || {});
var WalletRewardPeriod = /* @__PURE__ */ ((WalletRewardPeriod2) => {
  WalletRewardPeriod2["DAILY_BONUS"] = "daily-bonus";
  WalletRewardPeriod2["INSTANT_CASH_BACK"] = "instant-cash-back";
  WalletRewardPeriod2["DAILY_CASH_BACK"] = "daily-cash-back";
  WalletRewardPeriod2["WEEKLY_CASH_BACK"] = "weekly-cash-back";
  WalletRewardPeriod2["MONTHLY_CASH_BACK"] = "monthly-cash-back";
  return WalletRewardPeriod2;
})(WalletRewardPeriod || {});
var CashBackType = /* @__PURE__ */ ((CashBackType2) => {
  CashBackType2["Instant"] = "instant";
  CashBackType2["Daily"] = "daily";
  CashBackType2["Weekly"] = "weekly";
  CashBackType2["Monthly"] = "monthly";
  return CashBackType2;
})(CashBackType || {});
export {
  CashBackType,
  WalletRewardPeriod,
  WalletType
};
